import React, { Component, PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';

export class Loader extends Component {
  static propTypes = {
    message: PropTypes.string.isRequired
  };

  static defaultProps = {
    message: 'loading'
  };

  render() {
    return (
      <div className="loader">
        <FormattedMessage id={this.props.message} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/loader/Loader.js